(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const discounts = urlParams.get('discounts');

  if (!discounts) return;

  const codes = discounts
    .split(',')
    .map((code) => code.trim())
    .filter(Boolean);

  if (!codes.length) return;

  const applyDiscounts = async () => {
    for (const code of codes) {
      try {
        await fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' });
      } catch (error) {
        console.error(`Failed to apply discount code "${code}"`, error);
      }
    }
    // Optional: Redirect to cart or checkout after applying
    // window.location.href = '/checkout';
  };

  applyDiscounts();
})();
